import type { IOcrkV1DiagnosticReportCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/ocrkV1DiagnosticReportCustomControlData';
import type { ICustomControlDiagnosticReportReadProps } from '@frontend/components/pages/customControls/interfaces';
import { getDisplayName } from '@common/utils/getDisplayName';
import { booleanAsJaNee } from '@common/utils/textUtils';
import { DiagnosticReportReadButtons } from '@frontend/components/elements/carePathButtons/DiagnosticReportReadButtons';
import { translateKey } from '@frontend/translate';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { DiagnosticReportAfwijkingenRead } from '../../OORK/v1/components/DiagnosticReportAfwijkingenRead';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { FormGroupRead } from '../../utils/v1/FormGroupRead';

export function OcrkV1DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    const customControlData: IOcrkV1DiagnosticReportCustomControlData = props.diagnosticReport.customControlData;

    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                date={props.diagnosticReport?.dateSent}
                isFirstItem={props.isFirstItem}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.diagnosticReport.performerOrganization?.name}
                practitionerName={
                    props.diagnosticReport.performerPractitioner
                        ? getDisplayName(props.diagnosticReport.performerPractitioner)
                        : undefined
                }
                process={props.process}
                showProcessIcon={true}
                title={translateKey('diagnosticReport.category_consultReport')}
            />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                {!customControlData.is_grading_accepted && (
                    <DiagnosticReportAfwijkingenRead customControlData={customControlData} />
                )}

                <FormGroupRead
                    label="Betrokkene per videogesprek gesproken"
                    value={booleanAsJaNee(customControlData.betrokkene_gesproken_per_videogesprek)}
                />
                <FormGroupRead
                    label="Toelichting videogesprek"
                    value={customControlData.toelichting_videogesprek}
                />
                <FormGroupRead
                    label="Relevante comorbiditeit in relatie tot de rijgeschiktheid"
                    value={booleanAsJaNee(customControlData.relevante_comorbiditeit)}
                />
                <FormGroupRead
                    label="Toelichting relevante comorbiditeit"
                    value={customControlData.toelichting_relevante_comorbiditeit}
                />
                <FormGroupRead
                    label="Toelichting"
                    value={customControlData.toelichting}
                />
            </CustomControlCollapseBody>

            <DiagnosticReportReadButtons
                {...props}
                toastServiceLabelType="toast"
            />
        </ProcessContainer>
    );
}
